'use client';

import { initializeFirebaseClient } from '@util/firebase';
import type { ReactNode } from 'react';

// this provider ensures app check is init before all children firebase services are rendered
export default function FirebaseProvider({
  children,
}: {
  children: ReactNode;
}) {
  initializeFirebaseClient();
  return <>{children}</>;
}
